module.exports = __webpack_public_path__ + "static/media/Mission_mobile1_EN.8886934b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mission_mobile1_EN.png
// module id = 1062
// module chunks = 0